import { useParams } from "react-router-dom";
import AddCoverageContent from "./AddCoverageContent";

const AddCoveragePage = () => {
    const { id } = useParams();
    if (!id) return null;
    return <AddCoverageContent reservationId={id} />;
};

export default AddCoveragePage;
